import { css } from '@bts-web/utils-style-engine';
import { CellSkeleton } from '../components';

export const TransactionsWidgetSkeleton = () => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'column',
      gap: 'medium',
    })}
  >
    <div>
      <CellSkeleton />
      <CellSkeleton />
      <CellSkeleton />
    </div>
  </div>
);
